import { isJSON } from '@/helper/Json';

export const serializeQueryString = function(obj) {
    if (obj == null)
        return null;

    return Object.keys(obj).map(key => {

        if (Array.isArray(obj[key]) && isJSON(obj[key][0])) {
            return obj[key].map((item, index ) => {

                return Object.keys(item).map(subKey => 
                    key + '[' + index + '][' + subKey + ']' + '=' + item[subKey]
                ).join('&');

            }).join('&');
        }

        return key + '=' + obj[key];
    }).join('&')
}